import { Element } from 'html-react-parser'

export const getOriginalImageSrc = (src: string) => {
  return src?.replace(/w=\d+&?/, '').replace(/auto=[A-Za-z,]+&?/, '')
}

export const imgToImage = (domNode: Element) => {
  const { src, 'data-id': id } = domNode?.attribs || {}

  if (!src) {
    return undefined
  }

  return {
    id,
    downloadUrl: getOriginalImageSrc(src),
    url: src,
    cropX: 0,
    cropY: 0,
    cropZoom: 1,
  }
}

const getFigCaption = (domNode: any) => {
  const figcaptionNode = domNode.children.find(
    node => node.name === 'figcaption',
  )
  return figcaptionNode?.children[0]?.data
}

export const figureToImage = (domNode: any) => {
  const imageNode = domNode.children.find(node => node.name === 'img')
  const { src, 'data-id': id, alt } = imageNode?.attribs || {}

  const description = getFigCaption(domNode) || alt

  if (!src) {
    return undefined
  }

  return {
    id,
    downloadUrl: getOriginalImageSrc(src),
    description,
    url: src,
    cropX: 0,
    cropY: 0,
    cropZoom: 1,
  }
}
